// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_FAI","type":"styles_type__2hyw8","choices":"styles_choices__3A7Lj"};